import { Injectable } from '@angular/core';

import { EventOption } from '@frontend/sports/betting-offer/feature/model';

import { OptionNameStrategy } from './option-name.strategy';

@Injectable({ providedIn: 'root' })
export class OptionAttributeNameStrategy extends OptionNameStrategy {
    override getOptionName(option: EventOption): string {
        return option.optionAttribute || option.name;
    }
}
